import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let frontmatter = {
  "title": "0.3.1-beta",
  "description": "Navegación móvil personalizable, mejoras grandes de pedidos y caja, centro de documentación con asistente IA, tour guiado por rol y arreglos de QA."
};
export let structuredData = {
  "contents": [{
    "heading": "resumen",
    "content": "Esta versión está enfocada en hacer Orkestria más cómodo en celular, más rápido para operar y más fácil de aprender. También estrenamos el centro de documentación que estás leyendo, con un asistente Faki integrado, una guía interactiva por rol y bastantes pulidos de QA."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Nueva barra inferior** con tus 4 accesos directos favoritos siempre a la mano."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Personaliza tus accesos directos** desde `Perfil → Preferencias UI` o manteniendo presionado el botón `Más`."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Atajos agrupados**: el botón `Tomar pedido` despliega opciones para mesa o domicilio. El botón `Cobrar` también despliega opciones según el tipo de orden."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Tus preferencias te siguen entre dispositivos**: si cambias de celular o de computador, tu configuración se conserva."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Tres modos de navegación móvil**: barra inferior, menú hamburguesa, o ambos al mismo tiempo (por defecto)."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Cierra el menú deslizando hacia abajo** con un gesto natural."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Búsqueda en el menú** con botón para borrar lo escrito de un toque."
  }, {
    "heading": "navegación-en-celular",
    "content": "**Vuelve arriba automáticamente** cuando cambias de sección."
  }, {
    "heading": "navegación-en-celular",
    "content": "**El footer ya no queda tapado** por la barra inferior al hacer scroll hasta el final en celular."
  }, {
    "heading": "arrastrar-y-soltar",
    "content": "**Más cómodo de usar en celular**: el sistema espera un instante antes de empezar a arrastrar, así no interrumpe el scroll normal."
  }, {
    "heading": "arrastrar-y-soltar",
    "content": "**El elemento que arrastras sigue tu dedo con precisión**, sin desfasarse."
  }, {
    "heading": "arrastrar-y-soltar",
    "content": "**Scroll automático** cuando arrastras hacia los bordes de la pantalla, incluso entre paneles distintos (por ejemplo, al asignar productos a días en el horario semanal)."
  }, {
    "heading": "arrastrar-y-soltar",
    "content": "**Sin selección de texto accidental** al mantener presionado un elemento."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Comensales por grupo**: al iniciar una segunda ronda, el contador ya no se vuelve a sumar. Cada grupo de la mesa lleva su propio número de comensales."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Controles rápidos de comensales** con botones `−` y `+`, y un indicador en formato `{seleccionados}/{disponibles}`, restando los asientos ocupados por otros grupos."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Cambio fluido entre grupos**: al elegir un grupo existente, se restauran sus comensales; al crear un grupo nuevo, el contador arranca limpio."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Los descuentos del día se aplican correctamente** al agregar productos a una orden."
  }, {
    "heading": "pedidos-en-mesa",
    "content": "**Cliente \"Nuevo cliente\" directo en el selector**: al tomar pedido, tomar domicilio o cobrar, ya no tienes que cambiar de sección para registrar un cliente nuevo. Lo creas en un modal rápido y queda seleccionado automáticamente."
  }, {
    "heading": "corregir-pedido",
    "content": "**Rondas separadas por grupo**: cuando una mesa tiene varios grupos, las rondas se cuentan dentro de cada grupo, no en una sola lista."
  }, {
    "heading": "corregir-pedido",
    "content": "**Selector de grupo tipo pestaña** arriba del listado para alternar entre los grupos activos de la mesa."
  }, {
    "heading": "corregir-pedido",
    "content": "**Indicador de qué grupo estás viendo** (\"Mostrando Grupo X · N rondas · M comensales\") para que no haya duda."
  }, {
    "heading": "corregir-pedido",
    "content": "**Puedes volver a aumentar la cantidad de un producto desde cero** cuando corriges una orden."
  }, {
    "heading": "corregir-pedido",
    "content": "**Aviso a cocina al corregir un pedido**: si modificas un producto que va a cocina, el chef se entera."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**No se puede cerrar la mesa hasta que todas las rondas estén entregadas**: incluso si se hizo precobro, el sistema espera a que cocina + mesero terminen para evitar cobrar comida que no llegó."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**Pre-cobro a crédito ahora cierra correctamente**: al confirmar el cierre, la deuda queda registrada en la cuenta del cliente automáticamente."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**Selector \"Nuevo cliente\" inline** en `Cobrar orden` y `Cobrar domicilio`, tanto al asignar cliente a la orden como al cargar a cuenta de crédito."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**Facturación de grupos separada**: al cobrar mesas con varios grupos, cada grupo genera su propia factura/visita en `Órdenes completadas`. Antes se mezclaban los pedidos en una sola factura."
  }, {
    "heading": "caja-y-crédito-fiado",
    "content": "**Cobro mixto de grupos en la misma mesa**: ya puedes cobrar un grupo a crédito y otro con tarjeta/efectivo sin que el sistema confunda los grupos. Los grupos ya cargados a crédito dejan de bloquear el cobro de los grupos restantes."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Adiciones y observaciones con cargo aparecen en factura, ticket y correo**: cada extra que el cliente pidió (queso adicional, salsas, etc.) y las observaciones con costo se muestran como sub-líneas indentadas debajo del producto base. Ahora la suma de líneas coincide con el total cobrado."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Métodos de pago con etiquetas claras**: ya no se muestra `credit` ni `mixed` en inglés. Se ve \"A cuenta del cliente\" y \"Pago mixto\" en facturas, tickets y correos."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Pago mixto desglosado**: cuando un cobro se divide en dos métodos (ej. parte efectivo + parte tarjeta), la factura y el correo muestran cada método con su monto. Antes el correo enviaba un código de programación crudo."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Correo de factura completo**: cuando una visita tiene varias rondas, el correo enviado al cliente incluye TODAS las rondas como una sola factura combinada. Antes solo se enviaba la primera ronda."
  }, {
    "heading": "facturación-y-tickets",
    "content": "**Rondas separadas visualmente en factura combinada**: cuando una visita tiene varias rondas, la factura, el ticket térmico y el correo muestran un encabezado \"Ronda N · fecha/hora\" antes de los productos de cada una. Así se distingue claramente qué se pidió en cada momento."
  }, {
    "heading": "productos",
    "content": "**Acciones del producto agrupadas** en un solo botón con menú: editar, programar días, gestionar adiciones, eliminar y más, sin saturar la fila."
  }, {
    "heading": "productos",
    "content": "**Aviso visual de stock bajo o agotado** directamente en la lista."
  }, {
    "heading": "productos",
    "content": "**Adiciones** se refresca al instante después de crearlas o editarlas (antes había que recargar)."
  }, {
    "heading": "reservas",
    "content": "**Los meseros ya pueden arrastrar reservas** entre días, no solo dueños y administradores."
  }, {
    "heading": "reservas",
    "content": "**\"Nuevo cliente\" inline** también disponible al editar una reserva, para no salir del flujo."
  }, {
    "heading": "carta-digital",
    "content": "**Vista previa instantánea** al activar la carta: ya no hay que esperar a que el caché se renueve para verla."
  }, {
    "heading": "carta-digital",
    "content": "**Recomendaciones visibles** al subir el banner (relación 21:9, resolución sugerida, formatos, tamaño máximo) para evitar imágenes mal recortadas."
  }, {
    "heading": "carta-digital",
    "content": "**Código QR con el logo Orkestria al centro**, ahora visible en todos los temas."
  }, {
    "heading": "mesas",
    "content": "**Crear o cambiar de zona** desde el formulario ya no cierra el modal por accidente al interactuar con el selector."
  }, {
    "heading": "permisos-y-roles",
    "content": "**Meseros pueden crear clientes** directamente desde la lista o desde el selector inline en pedidos/reservas."
  }, {
    "heading": "permisos-y-roles",
    "content": "**Dueño sin restricciones**: arreglado el caso en que un dueño no podía abrir caja, eliminar invitaciones u operar acciones administrativas porque el sistema no lo reconocía como miembro de su propio restaurante. Ahora se le asigna automáticamente como dueño en el primer acceso."
  }, {
    "heading": "modales",
    "content": "**Modales más cómodos en celular**: el contenido largo ahora puede desplazarse sin romper el diseño."
  }, {
    "heading": "modales",
    "content": "**El fondo del modal bloquea correctamente** la interacción con la página detrás; ya no se puede hacer scroll por accidente."
  }, {
    "heading": "modales",
    "content": "**Los menús desplegables dentro de un modal** (selectores, combobox, etc.) ya no lo cierran al hacer clic dentro."
  }, {
    "heading": "modales",
    "content": "**El menú hamburguesa no abre el teclado** al abrirse."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**En celular, el chat se hace pequeño cuando Faki te muestra un resultado**, para que veas lo que hizo."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**El botón flotante de Faki ya no tapa la barra inferior**."
  }, {
    "heading": "faki-asistente-ia",
    "content": "**La guía visual se cancela automáticamente** si te vas a otra sección de la app durante el proceso. Antes Faki seguía intentando avanzar sobre la pantalla nueva."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Sección dedicada en `/docs`** con changelogs y manual de usuario, accesible para todos (no requiere iniciar sesión)."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Accesos desde toda la plataforma**: enlace en el landing, footer y dentro del dashboard."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Selector de versiones** para ver el detalle completo de cada release."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Cambio de tema dentro de docs** (claro, azul oscuro, noche): se sincroniza con el resto de la plataforma."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Asistente Faki integrado en docs**:"
  }, {
    "heading": "centro-de-documentación",
    "content": "**Conoce toda la documentación** y responde tus dudas en español con Markdown (negritas, listas, secciones)."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Page-agent**: te lleva al lugar exacto de la respuesta. Resalta la sección concreta con un anillo visual."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Dos modos**: flotante (sobre el contenido) o inmersivo (empuja el contenido a un lado, configurable y redimensionable)."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Abierto por defecto** en computador, cerrado por defecto en celular."
  }, {
    "heading": "centro-de-documentación",
    "content": "**Límite por dispositivo**: 10 consultas al día, sin afectar tu cuota de Faki en el resto de la app."
  }, {
    "heading": "tour-guiado-por-rol",
    "content": "**Primera vez que entras a un restaurante con un rol nuevo**: Faki te ofrece una guía rápida con paso a paso interactivo (resaltado, tooltips, navegación entre pestañas)."
  }, {
    "heading": "tour-guiado-por-rol",
    "content": "**Por rol**: dueño, administrador, mesero, chef, cajero, encargado de domicilios y encargado de inventario tienen tours adaptados a lo esencial de su trabajo."
  }, {
    "heading": "tour-guiado-por-rol",
    "content": "**Se muestra una sola vez por rol**, aunque pertenezcas a varios restaurantes."
  }, {
    "heading": "tour-guiado-por-rol",
    "content": "**Si lo saltas, no vuelve a aparecer**, pero siempre puedes preguntarle a Faki para repasarlo."
  }, {
    "heading": "temas",
    "content": "**Tema noche corregido en facturación** y otras zonas que se veían en blanco sobre blanco."
  }, {
    "heading": "temas",
    "content": "**El cambio de tema se sincroniza** entre el landing, la app y el centro de documentación."
  }, {
    "heading": "otros",
    "content": "**Video del landing** ya no se solapa con la barra superior en celular."
  }, {
    "heading": "otros",
    "content": "**Programar días de disponibilidad** de un producto desde su menú de acciones."
  }, {
    "heading": "otros",
    "content": "**Acceso desde red local**: la app se puede probar desde otro dispositivo en la misma red sin configurar nada extra."
  }],
  "headings": [{
    "id": "resumen",
    "content": "Resumen"
  }, {
    "id": "navegación-en-celular",
    "content": "Navegación en celular"
  }, {
    "id": "arrastrar-y-soltar",
    "content": "Arrastrar y soltar"
  }, {
    "id": "pedidos-en-mesa",
    "content": "Pedidos en mesa"
  }, {
    "id": "corregir-pedido",
    "content": "Corregir pedido"
  }, {
    "id": "caja-y-crédito-fiado",
    "content": "Caja y crédito (fiado)"
  }, {
    "id": "facturación-y-tickets",
    "content": "Facturación y tickets"
  }, {
    "id": "productos",
    "content": "Productos"
  }, {
    "id": "reservas",
    "content": "Reservas"
  }, {
    "id": "carta-digital",
    "content": "Carta digital"
  }, {
    "id": "mesas",
    "content": "Mesas"
  }, {
    "id": "permisos-y-roles",
    "content": "Permisos y roles"
  }, {
    "id": "modales",
    "content": "Modales"
  }, {
    "id": "faki-asistente-ia",
    "content": "Faki (asistente IA)"
  }, {
    "id": "centro-de-documentación",
    "content": "Centro de documentación"
  }, {
    "id": "tour-guiado-por-rol",
    "content": "Tour guiado por rol"
  }, {
    "id": "temas",
    "content": "Temas"
  }, {
    "id": "otros",
    "content": "Otros"
  }]
};
import {ChangelogHeader} from "@/components/docs/ChangelogHeader";
export let toc = [{
  depth: 2,
  url: "#resumen",
  title: _jsx(_Fragment, {
    children: "Resumen"
  })
}, {
  depth: 2,
  url: "#navegación-en-celular",
  title: _jsx(_Fragment, {
    children: "Navegación en celular"
  })
}, {
  depth: 2,
  url: "#arrastrar-y-soltar",
  title: _jsx(_Fragment, {
    children: "Arrastrar y soltar"
  })
}, {
  depth: 2,
  url: "#pedidos-en-mesa",
  title: _jsx(_Fragment, {
    children: "Pedidos en mesa"
  })
}, {
  depth: 2,
  url: "#corregir-pedido",
  title: _jsx(_Fragment, {
    children: "Corregir pedido"
  })
}, {
  depth: 2,
  url: "#caja-y-crédito-fiado",
  title: _jsx(_Fragment, {
    children: "Caja y crédito (fiado)"
  })
}, {
  depth: 2,
  url: "#facturación-y-tickets",
  title: _jsx(_Fragment, {
    children: "Facturación y tickets"
  })
}, {
  depth: 2,
  url: "#productos",
  title: _jsx(_Fragment, {
    children: "Productos"
  })
}, {
  depth: 2,
  url: "#reservas",
  title: _jsx(_Fragment, {
    children: "Reservas"
  })
}, {
  depth: 2,
  url: "#carta-digital",
  title: _jsx(_Fragment, {
    children: "Carta digital"
  })
}, {
  depth: 2,
  url: "#mesas",
  title: _jsx(_Fragment, {
    children: "Mesas"
  })
}, {
  depth: 2,
  url: "#permisos-y-roles",
  title: _jsx(_Fragment, {
    children: "Permisos y roles"
  })
}, {
  depth: 2,
  url: "#modales",
  title: _jsx(_Fragment, {
    children: "Modales"
  })
}, {
  depth: 2,
  url: "#faki-asistente-ia",
  title: _jsx(_Fragment, {
    children: "Faki (asistente IA)"
  })
}, {
  depth: 2,
  url: "#centro-de-documentación",
  title: _jsx(_Fragment, {
    children: "Centro de documentación"
  })
}, {
  depth: 2,
  url: "#tour-guiado-por-rol",
  title: _jsx(_Fragment, {
    children: "Tour guiado por rol"
  })
}, {
  depth: 2,
  url: "#temas",
  title: _jsx(_Fragment, {
    children: "Temas"
  })
}, {
  depth: 2,
  url: "#otros",
  title: _jsx(_Fragment, {
    children: "Otros"
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(ChangelogHeader, {
      version: "0.3.1-beta",
      date: "2026-05-13",
      tag: "Más reciente"
    }), "\n", _jsx(_components.h2, {
      id: "resumen",
      children: "Resumen"
    }), "\n", _jsx(_components.p, {
      children: "Esta versión está enfocada en hacer Orkestria más cómodo en celular, más rápido para operar y más fácil de aprender. También estrenamos el centro de documentación que estás leyendo, con un asistente Faki integrado, una guía interactiva por rol y bastantes pulidos de QA."
    }), "\n", _jsx(_components.h2, {
      id: "navegación-en-celular",
      children: "Navegación en celular"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Nueva barra inferior"
        }), " con tus 4 accesos directos favoritos siempre a la mano."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Personaliza tus accesos directos"
        }), " desde ", _jsx(_components.code, {
          children: "Perfil → Preferencias UI"
        }), " o manteniendo presionado el botón ", _jsx(_components.code, {
          children: "Más"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Atajos agrupados"
        }), ": el botón ", _jsx(_components.code, {
          children: "Tomar pedido"
        }), " despliega opciones para mesa o domicilio. El botón ", _jsx(_components.code, {
          children: "Cobrar"
        }), " también despliega opciones según el tipo de orden."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Tus preferencias te siguen entre dispositivos"
        }), ": si cambias de celular o de computador, tu configuración se conserva."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Tres modos de navegación móvil"
        }), ": barra inferior, menú hamburguesa, o ambos al mismo tiempo (por defecto)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cierra el menú deslizando hacia abajo"
        }), " con un gesto natural."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Búsqueda en el menú"
        }), " con botón para borrar lo escrito de un toque."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Vuelve arriba automáticamente"
        }), " cuando cambias de sección."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El footer ya no queda tapado"
        }), " por la barra inferior al hacer scroll hasta el final en celular."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "arrastrar-y-soltar",
      children: "Arrastrar y soltar"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Más cómodo de usar en celular"
        }), ": el sistema espera un instante antes de empezar a arrastrar, así no interrumpe el scroll normal."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El elemento que arrastras sigue tu dedo con precisión"
        }), ", sin desfasarse."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Scroll automático"
        }), " cuando arrastras hacia los bordes de la pantalla, incluso entre paneles distintos (por ejemplo, al asignar productos a días en el horario semanal)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Sin selección de texto accidental"
        }), " al mantener presionado un elemento."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "pedidos-en-mesa",
      children: "Pedidos en mesa"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Comensales por grupo"
        }), ": al iniciar una segunda ronda, el contador ya no se vuelve a sumar. Cada grupo de la mesa lleva su propio número de comensales."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Controles rápidos de comensales"
        }), " con botones ", _jsx(_components.code, {
          children: "−"
        }), " y ", _jsx(_components.code, {
          children: "+"
        }), ", y un indicador en formato ", _jsx(_components.code, {
          children: "{seleccionados}/{disponibles}"
        }), ", restando los asientos ocupados por otros grupos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cambio fluido entre grupos"
        }), ": al elegir un grupo existente, se restauran sus comensales; al crear un grupo nuevo, el contador arranca limpio."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Los descuentos del día se aplican correctamente"
        }), " al agregar productos a una orden."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cliente \"Nuevo cliente\" directo en el selector"
        }), ": al tomar pedido, tomar domicilio o cobrar, ya no tienes que cambiar de sección para registrar un cliente nuevo. Lo creas en un modal rápido y queda seleccionado automáticamente."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "corregir-pedido",
      children: "Corregir pedido"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Rondas separadas por grupo"
        }), ": cuando una mesa tiene varios grupos, las rondas se cuentan dentro de cada grupo, no en una sola lista."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Selector de grupo tipo pestaña"
        }), " arriba del listado para alternar entre los grupos activos de la mesa."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Indicador de qué grupo estás viendo"
        }), " (\"Mostrando Grupo X · N rondas · M comensales\") para que no haya duda."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Puedes volver a aumentar la cantidad de un producto desde cero"
        }), " cuando corriges una orden."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Aviso a cocina al corregir un pedido"
        }), ": si modificas un producto que va a cocina, el chef se entera."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "caja-y-crédito-fiado",
      children: "Caja y crédito (fiado)"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "No se puede cerrar la mesa hasta que todas las rondas estén entregadas"
        }), ": incluso si se hizo precobro, el sistema espera a que cocina + mesero terminen para evitar cobrar comida que no llegó."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Pre-cobro a crédito ahora cierra correctamente"
        }), ": al confirmar el cierre, la deuda queda registrada en la cuenta del cliente automáticamente."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Selector \"Nuevo cliente\" inline"
        }), " en ", _jsx(_components.code, {
          children: "Cobrar orden"
        }), " y ", _jsx(_components.code, {
          children: "Cobrar domicilio"
        }), ", tanto al asignar cliente a la orden como al cargar a cuenta de crédito."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Facturación de grupos separada"
        }), ": al cobrar mesas con varios grupos, cada grupo genera su propia factura/visita en ", _jsx(_components.code, {
          children: "Órdenes completadas"
        }), ". Antes se mezclaban los pedidos en una sola factura."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cobro mixto de grupos en la misma mesa"
        }), ": ya puedes cobrar un grupo a crédito y otro con tarjeta/efectivo sin que el sistema confunda los grupos. Los grupos ya cargados a crédito dejan de bloquear el cobro de los grupos restantes."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "facturación-y-tickets",
      children: "Facturación y tickets"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Adiciones y observaciones con cargo aparecen en factura, ticket y correo"
        }), ": cada extra que el cliente pidió (queso adicional, salsas, etc.) y las observaciones con costo se muestran como sub-líneas indentadas debajo del producto base. Ahora la suma de líneas coincide con el total cobrado."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Métodos de pago con etiquetas claras"
        }), ": ya no se muestra ", _jsx(_components.code, {
          children: "credit"
        }), " ni ", _jsx(_components.code, {
          children: "mixed"
        }), " en inglés. Se ve \"A cuenta del cliente\" y \"Pago mixto\" en facturas, tickets y correos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Pago mixto desglosado"
        }), ": cuando un cobro se divide en dos métodos (ej. parte efectivo + parte tarjeta), la factura y el correo muestran cada método con su monto. Antes el correo enviaba un código de programación crudo."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Correo de factura completo"
        }), ": cuando una visita tiene varias rondas, el correo enviado al cliente incluye TODAS las rondas como una sola factura combinada. Antes solo se enviaba la primera ronda."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Rondas separadas visualmente en factura combinada"
        }), ": cuando una visita tiene varias rondas, la factura, el ticket térmico y el correo muestran un encabezado \"Ronda N · fecha/hora\" antes de los productos de cada una. Así se distingue claramente qué se pidió en cada momento."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "productos",
      children: "Productos"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Acciones del producto agrupadas"
        }), " en un solo botón con menú: editar, programar días, gestionar adiciones, eliminar y más, sin saturar la fila."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Aviso visual de stock bajo o agotado"
        }), " directamente en la lista."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Adiciones"
        }), " se refresca al instante después de crearlas o editarlas (antes había que recargar)."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "reservas",
      children: "Reservas"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Los meseros ya pueden arrastrar reservas"
        }), " entre días, no solo dueños y administradores."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "\"Nuevo cliente\" inline"
        }), " también disponible al editar una reserva, para no salir del flujo."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "carta-digital",
      children: "Carta digital"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Vista previa instantánea"
        }), " al activar la carta: ya no hay que esperar a que el caché se renueve para verla."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Recomendaciones visibles"
        }), " al subir el banner (relación 21:9, resolución sugerida, formatos, tamaño máximo) para evitar imágenes mal recortadas."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Código QR con el logo Orkestria al centro"
        }), ", ahora visible en todos los temas."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "mesas",
      children: "Mesas"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Crear o cambiar de zona"
        }), " desde el formulario ya no cierra el modal por accidente al interactuar con el selector."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "permisos-y-roles",
      children: "Permisos y roles"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Meseros pueden crear clientes"
        }), " directamente desde la lista o desde el selector inline en pedidos/reservas."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Dueño sin restricciones"
        }), ": arreglado el caso en que un dueño no podía abrir caja, eliminar invitaciones u operar acciones administrativas porque el sistema no lo reconocía como miembro de su propio restaurante. Ahora se le asigna automáticamente como dueño en el primer acceso."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "modales",
      children: "Modales"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Modales más cómodos en celular"
        }), ": el contenido largo ahora puede desplazarse sin romper el diseño."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El fondo del modal bloquea correctamente"
        }), " la interacción con la página detrás; ya no se puede hacer scroll por accidente."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Los menús desplegables dentro de un modal"
        }), " (selectores, combobox, etc.) ya no lo cierran al hacer clic dentro."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El menú hamburguesa no abre el teclado"
        }), " al abrirse."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "faki-asistente-ia",
      children: "Faki (asistente IA)"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "En celular, el chat se hace pequeño cuando Faki te muestra un resultado"
        }), ", para que veas lo que hizo."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El botón flotante de Faki ya no tapa la barra inferior"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "La guía visual se cancela automáticamente"
        }), " si te vas a otra sección de la app durante el proceso. Antes Faki seguía intentando avanzar sobre la pantalla nueva."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "centro-de-documentación",
      children: "Centro de documentación"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: ["Sección dedicada en ", _jsx(_components.code, {
            children: "/docs"
          })]
        }), " con changelogs y manual de usuario, accesible para todos (no requiere iniciar sesión)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Accesos desde toda la plataforma"
        }), ": enlace en el landing, footer y dentro del dashboard."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Selector de versiones"
        }), " para ver el detalle completo de cada release."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cambio de tema dentro de docs"
        }), " (claro, azul oscuro, noche): se sincroniza con el resto de la plataforma."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Asistente Faki integrado en docs"
        }), ":", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Conoce toda la documentación"
            }), " y responde tus dudas en español con Markdown (negritas, listas, secciones)."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Page-agent"
            }), ": te lleva al lugar exacto de la respuesta. Resalta la sección concreta con un anillo visual."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Dos modos"
            }), ": flotante (sobre el contenido) o inmersivo (empuja el contenido a un lado, configurable y redimensionable)."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Abierto por defecto"
            }), " en computador, cerrado por defecto en celular."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Límite por dispositivo"
            }), ": 10 consultas al día, sin afectar tu cuota de Faki en el resto de la app."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "tour-guiado-por-rol",
      children: "Tour guiado por rol"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Primera vez que entras a un restaurante con un rol nuevo"
        }), ": Faki te ofrece una guía rápida con paso a paso interactivo (resaltado, tooltips, navegación entre pestañas)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Por rol"
        }), ": dueño, administrador, mesero, chef, cajero, encargado de domicilios y encargado de inventario tienen tours adaptados a lo esencial de su trabajo."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Se muestra una sola vez por rol"
        }), ", aunque pertenezcas a varios restaurantes."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Si lo saltas, no vuelve a aparecer"
        }), ", pero siempre puedes preguntarle a Faki para repasarlo."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "temas",
      children: "Temas"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Tema noche corregido en facturación"
        }), " y otras zonas que se veían en blanco sobre blanco."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "El cambio de tema se sincroniza"
        }), " entre el landing, la app y el centro de documentación."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "otros",
      children: "Otros"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Video del landing"
        }), " ya no se solapa con la barra superior en celular."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Programar días de disponibilidad"
        }), " de un producto desde su menú de acciones."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Acceso desde red local"
        }), ": la app se puede probar desde otro dispositivo en la misma red sin configurar nada extra."]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
